var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 0H2.66667C1.2 0 0 1.2 0 2.66667V21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V2.66667C24 1.2 22.8 0 21.3333 0ZM10.28 17.72C10.1566 17.8436 10.0101 17.9417 9.84883 18.0086C9.68754 18.0755 9.51462 18.1099 9.34 18.1099C9.16538 18.1099 8.99247 18.0755 8.83117 18.0086C8.66987 17.9417 8.52335 17.8436 8.4 17.72L3.61333 12.9333C3.48989 12.8099 3.39197 12.6633 3.32516 12.5021C3.25836 12.3408 3.22397 12.1679 3.22397 11.9933C3.22397 11.8188 3.25836 11.6459 3.32516 11.4846C3.39197 11.3233 3.48989 11.1768 3.61333 11.0533C3.73678 10.9299 3.88332 10.832 4.04461 10.7652C4.20589 10.6984 4.37876 10.664 4.55333 10.664C4.72791 10.664 4.90077 10.6984 5.06206 10.7652C5.22334 10.832 5.36989 10.9299 5.49333 11.0533L9.33333 14.8933L18.5067 5.72C18.756 5.4707 19.0941 5.33064 19.4467 5.33064C19.7992 5.33064 20.1374 5.4707 20.3867 5.72C20.636 5.9693 20.776 6.30743 20.776 6.66C20.776 7.01257 20.636 7.3507 20.3867 7.6L10.28 17.72Z",
    fill: "#1778E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkbox-on.647bcf2b.svg";
export { ForwardRef as ReactComponent };